<template>
  <div>
    <v-row justify="center">
      <v-dialog class="modal_medium" v-model="visible" persistent>
        <v-card>
          <v-form
            ref="form"
            v-model="valid"
            method="post"
            enctype="multipart/form-data"
            lazy-validation
          >
            <v-card-title>
              <span class="headl">AGREGAR DISPOSITIVO</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-alert v-if="textInfo.flag == true" type="warning">
                      <div class="ctn_alert">
                        <v-btn @click="textInfo.flag = false" color="#000" icon>
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <p class="ctn_alert_text">
                          {{ textInfo.text }}
                        </p>
                      </div>
                    </v-alert>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-combobox
                      ref="company"
                      v-model="form.company"
                      :items="itemsCompany"
                      :search-input.sync="search"
                      item-value="_id"
                      item-text="name"
                      label="Empresas"
                      placeholder="Digite el nombre de la empresa"
                      :disabled="isMaster == 0"
                      clearable
                      :rules="fieldRules"
                    ></v-combobox>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-combobox
                      v-model="form.device"
                      :items="arrayDevices"
                      :search-input.sync="searchDevice"
                      item-value="_id"
                      :item-text="getTextSensor"
                      label="Seleccione el sensor"
                      placeholder="Buscar por NUI, código interno, serial."
                      clearable
                      :rules="fieldRules"
                    >
                    </v-combobox>
                  </v-col>
                </v-row>
                <v-row> </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div class="ctn_btn_shop">
                <v-btn large text @click.stop="show = false">Cerrar</v-btn>
                <v-btn
                  :disabled="!valid"
                  depressed
                  large
                  color="primary"
                  @click="validate"
                  >ASOCIAR</v-btn
                >
              </div>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "AddDeviceIntegratorComp",
  components: {},
  props: ["visible", "data"],
  data() {
    return {
      form: {
        _id: null,
        company: null,
        device: null,
        activate: null,
      },
      search: "",
      itemsCompany: [],
      searchDevice: "",
      arrayDevices: [],
      pageDevice: 0,
      totalItems: 0,
      page: 0,
      totalNumberOfItems: 0,
      pagination: {
        page: +this.$route.query.page || 1,
        itemsPerPage: 10,
      },
      textInfo: { flag: false, text: "No exisite ningun valor" },
      arrayCompany: null,
      valid: true,
      fieldRules: [(v) => !!v || "El campo es requerido"],
    };
  },
  async mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        this.$refs.form.reset();
        this.$emit("close");
        // Or any other way you want to close your modal
      }
    });
    // evento despues de nueva estacion
    this.$root.$on("reload", async () => {
      await this.getJsonData();
      await this.getJsonDevice();
    });
    await this.getJsonData();
    await this.getJsonDevice();
  },
  watch: {
    search: {
      handler() {
        this.getJsonData().then((data) => {
          this.itemsCompany = data.docs;
        });
      },
      deep: true,
    },
    searchDevice: {
      handler() {
        this.getJsonDevice().then((data) => {
          this.arrayDevices = data.docs;
        });
      },
      deep: true,
    },
  },
  updated() {
    if(this.isMaster == 0) {
      this.form.company = this.itemsCompany[0];
    }
  },
  methods: {
    ...mapActions([
      "QueryIntegrator",
      "addDeviceIntegrator",
      "listCompany",
      "listDevice",
      "alertSnackbar",
    ]),
    getTextSensor(item) {
      return `Serial: ${item.serial} Nui: ${item.nui} Cod. Interno: ${item.alternateCode} `;
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.registerForm();
      }
    },
    async getJsonData() {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.$store.state.token };
          axios
            .get(
              `company/list?page=1&search=${this.search}`,
              {
                headers: headerToken,
              }
            )
            .then((res) => {
              this.itemsCompany = res.data.docs;
              this.totalNumberOfItems = res.data.totalDocs;
              resolve(res.data);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async getJsonDevice() {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.$store.state.token };

          let queryCompany = this.form.company ? "&company=" + this.form.company._id : "";

          axios
            .get(
              `device/listcustom?page=1&search=${this.searchDevice}${queryCompany}`,
              {
                headers: headerToken,
              }
            )
            .then((res) => {
              this.arrayDevices = res.data.docs;
              resolve(res.data);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async registerForm() {
      try {
        let finder = this.data._devices.find(
          (el) => el.device._id === this.form.device
        );
        if (finder != undefined) {
          this.textInfo = {
            flag: true,
            text: "El dispositivo ya fue asociado.",
          };
        } else {
          let formDt = {
            _id: this.data._id,
            company: this.form.company._id,
            device: this.form.device._id,
          };
          //console.log('lo enviado', formDt)
          let newData = await this.addDeviceIntegrator(formDt);
          this.$refs.form.reset();
          if (newData == 200) {
            this.textInfo = { flag: false };
            this.show = false;

            this.alertSnackbar({
              snackbar: true,
              text: "Se asocio el dispositivo.",
            });
            this.$root.$emit("reload");
            //await this.QueryIntegrator(this.data._id)
          }
        }
      } catch (error) {
        this.alertSnackbar({
          snackbar: true,
          text: "Error al asociar el dispositivo.",
        });
      }
    },
  },
  computed: {
    ...mapGetters([
      "getMessage",
      "getListCompany",
      "getFilterDevice",
      "isMaster",
    ]),
    DeviceSelect() {
      let filterR = this.getFilterDevice
        .map((item) => {
          if (item.company != undefined) {
            if (this.form.company == item.company._id) {
              return item;
            } else {
              return null;
            }
          } else {
            return null;
          }
        })
        .filter((item) => {
          return item;
        });
      return filterR;
    },
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.reset();
          this.textInfo = { flag: false };
          this.$emit("close");
        }
      },
    },
  },
};
</script>
<style lang="scss" scope>
@import "../../assets/scss/base.scss";
.unit_field {
  display: flex;
  position: relative;
  span {
    position: absolute;
    top: 33%;
    font-weight: 600;
    font-size: 1rem;
    right: 21px;
  }
}
.ctn_alert {
  position: relative;
  .v-btn {
    position: absolute;
    right: -8px;
    top: -10px;
  }
  p.ctn_alert_text {
    font-weight: 500;
    padding-top: 5px;
    color: #000;
    font-size: 0.95rem;
    line-height: 1.3;
    margin-right: 30px;
    margin-bottom: 0;
  }
}
</style>
